/* MAIYKO EKLENTI — Kazandıran Ürün Sayfası davranışları (v12 CRO)
   - Teslimat zaman çizelgesi (tarihler tarayıcıda hesaplanır)
   - Stok satırı: varyant değişince gerçek stoğa göre metin
   - Tükenen bedene tıklanınca "Stoğa gelince haber ver" diyaloğu
   - Sosyal kanıt etiket filtresi, sepete kaydır, yorumlara kaydır
   - "Bir soru sor" → Growave soru formu (yoksa WhatsApp)
   - Yıldız widget'ındaki "Bir soru sor" bağlantısı satın alma bölgesinden gizlenir
   Hepsi fail-open: bir parça yoksa sessizce atlanır. */
(function () {
  'use strict';

  var AYLAR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function gunEkle(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function isGunuEkle(d, n, pazarAtla) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (pazarAtla && x.getDay() === 0) continue;
      n -= 1;
    }
    return x;
  }
  function kisaTarih(d) { return d.getDate() + ' ' + AYLAR[d.getMonth()]; }

  /* ---------- Teslimat zaman çizelgesi ---------- */
  function teslimatKur() {
    qa('[data-kz-teslimat]').forEach(function (kok) {
      var kesim = parseInt(kok.getAttribute('data-kesim'), 10);
      var min = parseInt(kok.getAttribute('data-min'), 10);
      var max = parseInt(kok.getAttribute('data-max'), 10);
      var pazarAtla = kok.getAttribute('data-pazar') === '1';
      if (isNaN(kesim)) kesim = 14;
      if (isNaN(min) || min < 1) min = 1;
      if (isNaN(max) || max < min) max = min;

      var simdi = new Date();
      var kargo = new Date(simdi.getTime());
      if (simdi.getHours() >= kesim) kargo = gunEkle(kargo, 1);
      while (pazarAtla && kargo.getDay() === 0) kargo = gunEkle(kargo, 1);
      var teslimBas = isGunuEkle(kargo, min, pazarAtla);
      var teslimSon = isGunuEkle(kargo, max, pazarAtla);

      var s = q('[data-kz-tarih="siparis"]', kok);
      var k = q('[data-kz-tarih="kargo"]', kok);
      var t = q('[data-kz-tarih="teslim"]', kok);
      if (s) s.textContent = 'Bugün, ' + kisaTarih(simdi);
      if (k) k.textContent = (kargo.toDateString() === simdi.toDateString() ? 'Bugün, ' : '') + kisaTarih(kargo);
      if (t) {
        t.textContent = teslimBas.toDateString() === teslimSon.toDateString()
          ? kisaTarih(teslimBas)
          : (teslimBas.getMonth() === teslimSon.getMonth()
            ? teslimBas.getDate() + ' – ' + kisaTarih(teslimSon)
            : kisaTarih(teslimBas) + ' – ' + kisaTarih(teslimSon));
      }
      kok.classList.add('is-hazir');
    });
  }

  /* ---------- Stok satırı ---------- */
  function stokKur() {
    qa('[data-kz-stok]').forEach(function (kok) {
      var veriEl = q('[data-kz-varyantlar]', kok);
      var varyantlar = [];
      try { varyantlar = JSON.parse(veriEl ? veriEl.textContent : '[]') || []; } catch (e) { return; }
      var esik = parseInt(kok.getAttribute('data-esik'), 10) || 5;
      var metinEl = q('[data-kz-stok-metin]', kok);
      var haberBtn = q('[data-kz-haber-ac]', kok);
      var sectionId = kok.getAttribute('data-section');
      var sablon = {
        azTek: kok.getAttribute('data-metin-az-tek') || '[beden] bedeninde son 1 adet',
        azCok: kok.getAttribute('data-metin-az-cok') || '[beden] bedeninde son [adet] adet',
        vaR: kok.getAttribute('data-metin-var') || 'Stokta — hemen gönderime hazır',
        yok: kok.getAttribute('data-metin-yok') || 'Bu beden şu an tükendi'
      };
      var otoAcildi = {};

      function doldur(s, v) {
        return s.replace('[beden]', v.beden || '').replace('{beden}', v.beden || '').replace('[adet]', v.qty == null ? '' : v.qty).replace('{adet}', v.qty == null ? '' : v.qty);
      }

      function uygula(v, otomatikAc) {
        if (!v || !metinEl) return;
        var durum = 'var';
        if (!v.avail) durum = 'yok';
        else if (v.takip && v.qty != null && v.qty > 0 && v.qty <= esik) durum = 'az';
        kok.classList.remove('kz-stok--var', 'kz-stok--az', 'kz-stok--yok');
        kok.classList.add('kz-stok--' + durum);
        if (durum === 'yok') metinEl.textContent = sablon.yok;
        else if (durum === 'az') metinEl.textContent = doldur(v.qty === 1 ? sablon.azTek : sablon.azCok, v);
        else metinEl.textContent = sablon.vaR;
        kok.hidden = false;
        if (durum === 'var' && !sablon.vaR) kok.hidden = true;
        if (haberBtn) haberBtn.hidden = durum !== 'yok';
        var bedenEl = q('[data-kz-haber-beden]');
        var bedenInput = q('[data-kz-haber-beden-input]');
        var body = q('[data-kz-haber-body]');
        if (bedenEl) bedenEl.textContent = v.beden || '';
        if (bedenInput) bedenInput.value = v.beden || '';
        if (body) body.value = (body.getAttribute('data-sablon') || 'Stoğa gelince haber ver: {urun} / {beden}')
          .replace('{urun}', body.getAttribute('data-urun') || '').replace('{beden}', v.beden || '');
        /* Tükenen bedene TIKLANDIĞINDA form kendiliğinden açılır (her beden için bir kez). */
        if (durum === 'yok' && otomatikAc && !otoAcildi[v.id]) {
          otoAcildi[v.id] = true;
          haberAc(v.beden);
        }
      }

      function seciliVaryant() {
        var kap = sectionId ? (document.getElementById('variant-radios-' + sectionId) || document.getElementById('variant-selects-' + sectionId)) : null;
        if (!kap) kap = q('variant-radios, variant-selects');
        if (!kap) return null;
        var secilen = [];
        qa('fieldset', kap).forEach(function (fs) {
          var r = q('input[type="radio"]:checked', fs);
          if (r) secilen.push(r.value);
        });
        qa('select', kap).forEach(function (sel) { secilen.push(sel.value); });
        if (!secilen.length) return null;
        for (var i = 0; i < varyantlar.length; i++) {
          var o = varyantlar[i].opts || [];
          var tam = o.length === secilen.length;
          for (var j = 0; tam && j < o.length; j++) if (o[j] !== secilen[j]) tam = false;
          if (tam) return varyantlar[i];
        }
        return null;
      }

      function idIle(id) {
        for (var i = 0; i < varyantlar.length; i++) if (String(varyantlar[i].id) === String(id)) return varyantlar[i];
        return null;
      }

      /* Tema olayı (pubsub) varsa onu dinle; yoksa/ek olarak radyo/select değişimi. */
      try {
        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
          window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
            var v = ev && ev.data && ev.data.variant;
            if (v && v.id) uygula(idIle(v.id) || seciliVaryant(), true);
          });
        }
      } catch (e) { /* yoksay */ }
      document.addEventListener('change', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('variant-radios, variant-selects')) return;
        window.setTimeout(function () { uygula(seciliVaryant(), true); }, 30);
      });
      if (haberBtn) haberBtn.addEventListener('click', function () {
        var v = seciliVaryant(); haberAc(v ? v.beden : '');
      });

      var ilk = null;
      var ilkId = kok.getAttribute('data-ilk');
      if (ilkId) ilk = idIle(ilkId);
      uygula(ilk || seciliVaryant() || varyantlar[0], false);
    });
  }

  /* ---------- Stoğa gelince haber ver diyaloğu ---------- */
  var sonOdak = null;
  function haberAc(beden) {
    var d = q('[data-kz-haber]');
    if (!d) return;
    var bedenEl = q('[data-kz-haber-beden]', d);
    var bedenInput = q('[data-kz-haber-beden-input]', d);
    var body = q('[data-kz-haber-body]', d);
    if (beden) {
      if (bedenEl) bedenEl.textContent = beden;
      if (bedenInput) bedenInput.value = beden;
      if (body) body.value = (body.getAttribute('data-sablon') || 'Stoğa gelince haber ver: {urun} / {beden}')
        .replace('{urun}', body.getAttribute('data-urun') || '').replace('{beden}', beden);
    }
    sonOdak = document.activeElement;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    var mail = q('input[type="email"]', d);
    if (mail) window.setTimeout(function () { try { mail.focus(); } catch (e) { /* yoksay */ } }, 40);
  }
  function haberKapat() {
    var d = q('[data-kz-haber]');
    if (!d || d.hidden) return;
    d.hidden = true;
    document.body.style.overflow = '';
    if (sonOdak && sonOdak.focus) { try { sonOdak.focus(); } catch (e) { /* yoksay */ } }
  }
  function haberKur() {
    var d = q('[data-kz-haber]');
    if (!d) return;
    /* Diyalog body'ye taşınır: sticky/transform'lu ata kapsayıcılar fixed konumu bozmasın. */
    if (d.parentNode !== document.body) document.body.appendChild(d);
    qa('[data-kz-haber-kapat]', d).forEach(function (b) { b.addEventListener('click', haberKapat); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') haberKapat(); });
    /* Form gönderildi ve Shopify başarıyla geri döndüyse teşekkür ekranı açık gelir. */
    if (q('[data-kz-haber-basarili]', d) || /contact_posted=true/.test(window.location.search)) {
      window.setTimeout(function () { haberAc(''); }, 200);
    }
  }
  window.MaiykoStokHaberAc = haberAc;

  /* ---------- Sepete kaydır / yorumlara kaydır ---------- */
  function sepeteKaydir() {
    var hedef = q('[id^="ProductSubmitButton-"]') || q('.product-form__submit') || q('product-form');
    if (!hedef) return;
    hedef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    hedef.classList.add('kz-vurgu');
    window.setTimeout(function () { hedef.classList.remove('kz-vurgu'); }, 1600);
  }
  function yorumlaraKaydir() {
    var hedef = q('#maiyko-yorumlar') || q('.gw-rv-main-widget-placeholder') || q('[class*="review"]');
    if (hedef) hedef.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- Sosyal kanıt etiket filtresi ---------- */
  function kanitKur() {
    qa('[data-kz-kanit]').forEach(function (kok) {
      var chips = qa('[data-kz-etiket]', kok);
      var kartlar = qa('[data-kz-kart]', kok);
      function filtrele(etiket) {
        kartlar.forEach(function (k) {
          var e = (k.getAttribute('data-etiket') || '').toLowerCase().split(',').map(function (x) { return x.trim(); });
          k.hidden = !!etiket && e.indexOf(etiket) === -1;
        });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var secili = c.classList.contains('is-secili');
          chips.forEach(function (x) { x.classList.remove('is-secili'); });
          if (secili) { filtrele(''); return; }
          c.classList.add('is-secili');
          filtrele((c.getAttribute('data-kz-etiket') || '').toLowerCase());
        });
      });
    });
    qa('[data-kz-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); sepeteKaydir(); }); });
    qa('[data-kz-yorumlar]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); yorumlaraKaydir(); }); });
  }

  /* ---------- "Bir soru sor" ---------- */
  function growaveSoruBul() {
    var kokler = qa('.gw-rv-star-rating-widget-placeholder, .gw-rv-main-widget-placeholder');
    for (var i = 0; i < kokler.length; i++) {
      var r = kokler[i].shadowRoot || kokler[i];
      var adaylar = qa('a, button', r);
      for (var j = 0; j < adaylar.length; j++) {
        if (/soru/i.test(adaylar[j].textContent || '')) return adaylar[j];
      }
    }
    return null;
  }
  function soruKur() {
    qa('[data-kz-soru]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var g = growaveSoruBul();
        if (g) { e.preventDefault(); try { g.click(); return; } catch (err) { /* düş */ } }
        var wa = b.getAttribute('data-kz-wa');
        if (wa) { e.preventDefault(); window.open(wa, '_blank', 'noopener'); }
      });
    });
  }

  /* Satın alma bölgesindeki (yıldız widget'ı) "Bir soru sor" bağlantısını gizle —
     soru sorma SSS bölümünün altına taşındı (Han Agency önerisi). Yalnız bu şablonda. */
  function soruLinkiGizle() {
    if (!q('[data-kz-sayfa]')) return;
    function uygula() {
      qa('.gw-rv-star-rating-widget-placeholder').forEach(function (w) {
        var r = w.shadowRoot || w;
        qa('a, button, span', r).forEach(function (el) {
          if (/^\s*bir soru sor/i.test(el.textContent || '') && el.children.length < 3) {
            el.style.display = 'none';
            var sep = el.previousElementSibling;
            if (sep && /^\s*[|·]\s*$/.test(sep.textContent || '')) sep.style.display = 'none';
          }
        });
      });
    }
    uygula();
    try {
      var mo = new MutationObserver(function () { uygula(); });
      mo.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { mo.disconnect(); }, 15000);
    } catch (e) { /* yoksay */ }
  }

  function baslat() {
    if (q('[data-kz-sayfa]')) document.body.classList.add('kz-sayfa');
    teslimatKur();
    stokKur();
    haberKur();
    kanitKur();
    soruKur();
    soruLinkiGizle();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();

/* ===== KZ YORUM VİTRİNİ (maiyko_kz_yorum) — kayan/alinti: otomatik geçiş + noktalar + dokunarak kaydırma ===== */
(function () {
  function kur(kok) {
    var ogeler = Array.prototype.slice.call(kok.querySelectorAll('[data-kz-yorum-oge]'));
    if (ogeler.length < 2) return;
    var nok = kok.querySelector('[data-kz-yorum-nok]'); var i = 0; var zaman = null; var butonlar = [];
    var sure = parseInt(kok.getAttribute('data-sure') || '5', 10) * 1000;
    var azHareket = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function git(n) {
      i = (n + ogeler.length) % ogeler.length;
      ogeler.forEach(function (o, k) { o.classList.toggle('is-aktif', k === i); });
      butonlar.forEach(function (b, k) { b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function dur() { if (zaman) { window.clearInterval(zaman); zaman = null; } }
    function basla() { dur(); if (sure > 0 && !azHareket) zaman = window.setInterval(function () { git(i + 1); }, sure); }
    if (nok) {
      ogeler.forEach(function (_, k) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', (k + 1) + '. yorum');
        b.addEventListener('click', function () { git(k); basla(); }); nok.appendChild(b); butonlar.push(b);
      });
    }
    var x0 = null;
    kok.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; dur(); }, { passive: true });
    kok.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) git(dx < 0 ? i + 1 : i - 1); basla();
    }, { passive: true });
    kok.addEventListener('mouseenter', dur); kok.addEventListener('mouseleave', basla);
    git(0); basla();
  }
  function hepsi() {
    document.querySelectorAll('[data-kz-yorum]').forEach(function (k) {
      if (k.getAttribute('data-kz-yorum-kuruldu')) return; k.setAttribute('data-kz-yorum-kuruldu', '1');
      var t = k.getAttribute('data-tasarim'); if (t === 'kayan' || t === 'alinti') kur(k);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
